<template>
  <div class="not">
    移动端 ~ 404
    <div class="dev">哈哈{{ msg }}</div>
  </div>
</template>

<script>
export default {
  name: 'Test',
  props: {
    // msg: String
  }
}
</script>

<style scoped lang="less">
.not {
  border: 1px solid red;
 .dev {
  font-size: 30px;
 }
}
</style>
